import React, { Component } from 'react'
import { Input, Alert, Button, Icon } from 'antd'

import { rights } from '@services/api'

export default class RightsPopup extends Component<any, any> {
    state: any = {
        name: null,
        visibility: false,
        deleteRight: false,
        error: null
    }
    componentDidMount() {
        const { name } = this.props
        this.setState({ name })
    }
    toggleDelete = () => {
        this.setState(prevState => ({ deleteRight: !prevState.deleteRight }))
    }
    toggleRight = () => {
        this.setState(prevState => ({ visibility: !prevState.visibility }))
        this.handleCancelEdit()
    }
    handleNameChange = name => {
        this.setState({ name })
    }
    handleSubmitRight = async () => {
        const { name } = this.state
        const { id, right_param_set_id, rightUpdated } = this.props
        if (id) {
            await rights
                .updateRight({ name, id })
                .then(res => {
                    rightUpdated()
                    this.toggleRight()
                })
                .catch(e => {
                    if (e.response.status === 404) {
                        this.setState({ error: `לא קיים כיסוי עם מזהה ${id}` })
                    } else if (e.response.status === 400) {
                        this.setState({ error: 'כיסוי זה קיים תחת סוג וקטגוריה אלה' })
                    } else {
                        this.setState({ error: 'ישנה בעיה בהתחברות לשרת' })
                    }
                })
        } else {
            await rights
                .addRight({ name, right_param_set_id })
                .then(res => {
                    rightUpdated()
                    this.toggleRight()
                })
                .catch(e => {
                    if (e.response.status === 404) {
                        this.setState({ error: `לא קיימת טבלה עם מזהה ${right_param_set_id}` })
                    } else if (e.response.status === 400) {
                        this.setState({ error: 'כיסוי עם שם זה כבר קיים תחת קטגוריה זו' })
                    } else {
                        this.setState({ error: 'ישנה בעיה בהתחברות לשרת' })
                    }
                })
        }
    }
    handleDeleteRight = async () => {
        const { id, rightUpdated } = this.props
        if (id) {
            await rights
                .deleteRight(id)
                .then(async res => {
                    await rightUpdated()
                })
                .catch(e => {
                    if (e.response.status === 404) {
                        this.setState({ error: `לא נמצא כיסוי עם מזהה ${id}` })
                    } else {
                        this.setState({ error: 'ישנה בעיה בהתחברות לשרת' })
                    }
                })
        } else {
            this.setState({ error: `לא ניתן למחוק כיסוי ללא מזהה` })
        }
    }
    handleCancelEdit = () => {
        const { name } = this.props
        this.setState({ name, error: null, deleteRight: false })
    }
    render() {
        const { id } = this.props
        const { name, visibility, error, deleteRight } = this.state
        const { updated_by } = this.props
        return (
            <div
                style={{
                    padding: '0.7rem 0',
                    borderBottom: '1px solid #e2e2e2',
                    backgroundColor: `${visibility ? '#e2e2e2' : 'initial'}`
                }}
            >
                <div onClick={() => this.toggleRight()} style={{ cursor: 'pointer', padding: '0 0.5rem 0 1rem' }}>
                    <strong>
                        {id ? (
                            <span>
                                <span style={{ marginLeft: '0.5rem' }}>
                                    {visibility ? <Icon type="down" /> : <Icon type="left" />}
                                </span>
                                {this.props.name}
                                <span style={{ float: 'left', fontWeight: 'normal' }}>{updated_by}</span>
                            </span>
                        ) : (
                            <Button type="primary">
                                <Icon type="plus" /> הוספת כיסוי
                            </Button>
                        )}
                    </strong>
                </div>
                {!!error && <Alert type="error" message={error} />}
                {!!visibility && (
                    <div style={{ marginTop: '0.5rem', padding: '0 1rem' }}>
                        <Input
                            autoComplete="off"
                            placeholder="הזן את שם הכיסוי"
                            name="name"
                            value={name}
                            onChange={e => this.handleNameChange(e.target.value)}
                        />
                        {!!deleteRight && (
                            <div
                                style={{
                                    background: '#9c2222',
                                    padding: '0.5rem',
                                    marginBottom: '0.4rem',
                                    color: 'white',
                                    textAlign: 'center'
                                }}
                            >
                                <span>
                                    <strong style={{ fontSize: '1.2rem' }}>אזהרה!</strong> מחיקת כיסוי זה תגרור
                                    <strong>מחיקה של כל ההגדרות</strong> הרלוונטיות לכיסוי זה בכל הפוליסות המקושרות
                                    אליו, האם בכל זאת למחוק כיסוי זה?
                                </span>
                                <br />
                                <a
                                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                                    onClick={() => this.toggleDelete()}
                                >
                                    בטל מחיקה
                                </a>
                                |
                                <a
                                    onClick={() => this.handleDeleteRight()}
                                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                                >
                                    מחק כיסוי
                                </a>
                            </div>
                        )}
                        <Button
                            type="primary"
                            disabled={name === this.props.name || name === ''}
                            onClick={() => this.handleSubmitRight()}
                        >
                            {id ? (
                                <span>
                                    <Icon type="check" /> שמור שינויים
                                </span>
                            ) : (
                                'הוסף כיסוי'
                            )}
                        </Button>
                        {!!(name !== this.props.name && name !== '') && (
                            <Button onClick={() => this.handleCancelEdit()}>
                                <Icon type="stop" /> ביטול
                            </Button>
                        )}
                        {!!(id && !deleteRight) && (
                            <span style={{ float: 'left' }}>
                                <Button style={{ marginLeft: '0' }} onClick={() => this.toggleDelete()}>
                                    <Icon type="delete" /> מחק כיסוי
                                </Button>
                            </span>
                        )}
                    </div>
                )}
            </div>
        )
    }
}
